import { Repository } from '../../../core/context/repository';
import { type ProtectionGoal } from './entity';

export class ProtectionGoals extends Repository<ProtectionGoal> {}
